// ***** Library Imports *****
import { Route, Routes } from "react-router-dom";

import { ProtectedRoute } from "@/app/(protected)/protected-route";

import AdminLayout from "@/app/(protected)/admin/layout";
import AdminHomePage from "@/app/(protected)/admin/page";
import EmployeesPageofAdmin from "@/app/(protected)/admin/employees/page";
import NewEmployeePage from "@/app/(protected)/admin/employees/new/page";
import EditEmployeePage from "@/app/(protected)/admin/employees/[empId]/page";

import AdminHolidaysPage from "@/app/(protected)/admin/holidays/page";
import NewHolidayListPage from "@/app/(protected)/admin/holidays/new/page";
import EditHolidayListPage from "@/app/(protected)/admin/holidays/[holidayListId]/page";

import AdminCompanyHolidaysPage from "@/app/(protected)/admin/company-holidays/page";
import NewCompanyHolidayListPage from "@/app/(protected)/admin/company-holidays/new/page";
import EditCompanyHolidayListPage from "@/app/(protected)/admin/company-holidays/[companyHolidayId]/page";

import AdminLeaveApplicationsPage from "@/app/(protected)/admin/leave-applications/page";
import EmployeePermissions from "@/app/(protected)/admin/employee-permissions/page";
import LeadsAdminPage from "@/app/(protected)/admin/leads/page";
import AdminAllowancePage from "@/app/(protected)/admin/allowance/page";
// import AdminLoanPage from "@/app/(protected)/admin/loan/page";
// import AdminIndividualLoanPage from "@/app/(protected)/admin/loan/[loanId]/page";
import AdminTodosPage from "@/app/(protected)/admin/todos/page";
import AdminIndividualTodoPage from "@/app/(protected)/admin/todos/[todoId]/page";
import EmployeeAttendancePageForAdmin from "@/app/(protected)/admin/attendance-requests/page";
// TODO: Missing files - performance/logs pages don't exist
// import EmployeePerformanceLogsForAdmin from "@/app/(protected)/admin/performance/logs/page";
// import OneEmployeePerformanceLogsPageForAdmin from "@/app/(protected)/admin/performance/logs/[empId]/page";
import EmployeePerformanceReportsForAdmin from "@/app/(protected)/admin/performance/reports/page";
import OneEmployeePerformanceReportPageForAdmin from "@/app/(protected)/admin/performance/reports/[empId]/page";
import TodosProgressOfEmployees from "@/app/(protected)/admin/todos/todos-progress/page";
import SingleEmployeeTodosProgressPage from "@/app/(protected)/admin/todos/todos-progress/[empId]/page";
import UploadLeadsForAdmin from "@/app/(protected)/admin/leads/upload/page";
import EmployeeSalary from "@/app/(protected)/admin/employees/salary/page";
import NotificationsPageForAdmin from "@/app/(protected)/admin/notifications/page";
import AdminAnnouncements from "@/app/(protected)/admin/announcements/page";
import EmployeeAttendanceForAdmin from "@/app/(protected)/admin/employees/attendance/page";
import OtherLoansOfEmployee from "@/app/(protected)/admin/other-loans/page";
import IndividualLoanPageByAdmin from "@/app/(protected)/admin/other-loans/[loanId]/page";
import SalaryTimesheetsPageAdmin from "@/app/(protected)/admin/salary-timesheets/page";
import EmployeeSalaries from "@/app/(protected)/admin/salaries/page";
// import AllEmployeesPageForAdmin from "@/app/(protected)/admin/all-employees/page";
import SingleEmployeeProfile from "@/app/(protected)/admin/all-employees/[empId]/page";
import DayWiseCheckinsPage from "@/app/(protected)/admin/checkins/page";
import EmployeesMonthlyReport from "@/app/(protected)/admin/employees/monthly-report/page";
import AdminLeadsReportPage from "@/app/(protected)/admin/leads/(routes)/leads-report/page";
import AttendanceChangeLogsPage from "@/app/(protected)/admin/attendance-change-logs/page";

const AdminRoutes = () => {
  return (
    <Routes>
      <Route element={<ProtectedRoute />}>
        <Route element={<AdminLayout />}>
          <Route index path="/" element={<AdminHomePage />} />
          <Route path="/employees" element={<EmployeesPageofAdmin />} />
          <Route
            path="/employees/monthly-report"
            element={<EmployeesMonthlyReport />}
          />
          <Route path="/employees/new" element={<NewEmployeePage />} />
          <Route path="/employees/:empId" element={<EditEmployeePage />} />
          <Route path="/employees/salary/:empId" element={<EmployeeSalary />} />
          <Route
            path="/employees/attendance/:empId"
            element={<EmployeeAttendanceForAdmin />}
          />

          {/* <Route path="/all-employees" element={<AllEmployeesPageForAdmin />} /> */}
          <Route
            path="/all-employees/:empId"
            element={<SingleEmployeeProfile />}
          />

          <Route
            path="/employee-permissions"
            element={<EmployeePermissions />}
          />

          <Route path="/holidays" element={<AdminHolidaysPage />} />
          <Route path="/holidays/new" element={<NewHolidayListPage />} />
          <Route
            path="/holidays/:holidayListId"
            element={<EditHolidayListPage />}
          />

          <Route path="/company-holidays" element={<AdminCompanyHolidaysPage />} />
          <Route path="/company-holidays/new" element={<NewCompanyHolidayListPage />} />
          <Route
            path="/company-holidays/:companyHolidayId"
            element={<EditCompanyHolidayListPage />}
          />

          <Route
            path="/salary-timesheets"
            element={<SalaryTimesheetsPageAdmin />}
          />
          <Route path="/salaries" element={<EmployeeSalaries />} />

          <Route
            path="/leave-applications"
            element={<AdminLeaveApplicationsPage />}
          />
          <Route path="/leads" element={<LeadsAdminPage />} />
          <Route path="/leads/upload" element={<UploadLeadsForAdmin />} />
          <Route path="/leads/reports" element={<AdminLeadsReportPage />} />
          <Route path="/allowance" element={<AdminAllowancePage />} />

          {/* <Route path="/loan" element={<AdminLoanPage />} /> */}
          {/* <Route path="/loan/:loanId" element={<AdminIndividualLoanPage />} /> */}
          <Route path="/other-loans" element={<OtherLoansOfEmployee />} />
          <Route
            path="/other-loans/:loanId"
            element={<IndividualLoanPageByAdmin />}
          />

          <Route path="/todos" element={<AdminTodosPage />} />
          <Route path="/todos/:todoId" element={<AdminIndividualTodoPage />} />
          <Route
            path="/todos/employee-progress"
            element={<TodosProgressOfEmployees />}
          />
          <Route
            path="/todos/employee-progress/:empId"
            element={<SingleEmployeeTodosProgressPage />}
          />

          <Route
            path="/employee-attendance-requests"
            element={<EmployeeAttendancePageForAdmin />}
          />

          {/* TODO: Missing files - performance/logs pages don't exist */}
          {/* <Route
            path="/performance/logs"
            element={<EmployeePerformanceLogsForAdmin />}
          />

          <Route
            path="/performance/logs/:empId"
            element={<OneEmployeePerformanceLogsPageForAdmin />}
          /> */}

          <Route
            path="/performance/reports"
            element={<EmployeePerformanceReportsForAdmin />}
          />

          <Route
            path="/performance/reports/:empId"
            element={<OneEmployeePerformanceReportPageForAdmin />}
          />

          <Route
            path="/notifications"
            element={<NotificationsPageForAdmin />}
          />
          <Route path="/announcements" element={<AdminAnnouncements />} />

          <Route path="/checkins" element={<DayWiseCheckinsPage />} />

          <Route
            path="/attendance-change-logs"
            element={<AttendanceChangeLogsPage />}
          />
        </Route>
      </Route>
    </Routes>
  );
};

export default AdminRoutes;
